import { ResolveFn } from '@angular/router';
import { PORT_DATA } from './port-loaders';
import { UsPort } from './port-types';

// A resolver, not ngOnInit: the router waits for it, so server rendering always has the data.
// The route's canMatch has already checked the port exists.
// port-copy is imported on demand so the port index stays out of the main bundle.
export const usPortResolver: ResolveFn<UsPort | undefined> = async route => {
  const { findUsPort } = await import('./port-copy');
  const entry = findUsPort(route.paramMap.get('port'));
  if (!entry) return undefined;
  const list = await PORT_DATA[entry.district]();
  return list.find(p => p.code === entry.code);
};
